import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteFetch, getFetch } from '../../../utils/fetch';

export function useInitialMessages({ courseId, apiHost }) {
  return useQuery({
    queryKey: ['initialMessages', courseId],
    queryFn: async () => {
      const response = await getFetch(
        `${apiHost}/api/v1/sections-chat/${courseId}/initial-messages`,
      );
      return await response.json();
    },
  });
}

export function useDeleteMessage({ apiHost }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ courseId }) => {
      await deleteFetch(
        `${apiHost}/api/v1/sections-chat/${courseId}/chat-messages`,
      );
      // Invalidate the query
      queryClient.invalidateQueries({
        queryKey: ['initialMessages', courseId],
      });
    },
  });
}

export function useChatDataById({ courseId, chatDataId, apiHost, enabled }) {
  return useQuery({
    queryKey: ['chatDataById', courseId, chatDataId],
    queryFn: async () => {
      const response = await getFetch(
        `${apiHost}/api/v1/sections-chat/${courseId}/chat-data/${chatDataId}`,
      );
      return await response.json();
    },
    enabled: enabled && !!courseId && !!chatDataId,
  });
}

export function useAssignmentNames({ courseId, apiHost }) {
  return useQuery({
    queryKey: ['assignmentNames', courseId],
    queryFn: async () => {
      const response = await getFetch(
        `${apiHost}/api/v1/sections-chat/${courseId}/assignment-names`,
      );
      const data = await response.json();
      return data || [];
    },
    enabled: !!courseId,
  });
}
